<template>
    <div
        style="
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
        "
    >
        <div v-if="headerVisible" class="vod-content-header">
            <div class="header-photo">
                <img src="@/assets/img/headers/header.png" alt="" />
            </div>
            <h4><strong>EDYCJA V</strong></h4>
            <h2>E-konferencja LiveKid "Zainspirowani w przedszkolu"</h2>
            <p>
                Wracamy do tematu kreatywności w przedszkolu z nową energią i
                nowymi pomysłami! Przywitajmy wspólnie jesień, która wcale nie
                musi być szara i nudna. Podczas naszej e-konferencji wspólnie
                zdobędziemy inspiracje do zajęć, którymi pokolorujemy pięknie
                jesienne dni, i nie tylko! Nie zabraknie materiałów dodatkowych,
                a także imiennych certyfikatów udziału w szkoleniach.
            </p>
            <div>
                <div class="vod-see-button" @click="goToConference">
                    <i class="material-icons">play_arrow</i>
                    Zakup bilet
                </div>
            </div>
        </div>
        <div
            class="vod-content-container"
            :class="{ 'without-header': !headerVisible }"
        >
            <VodContentCarousel
                v-if="teacherContent"
                :content="teacherContent"
                type="teacher"
                title="Dla wychowawcy"
            />
            <VodContentCarousel
                v-if="parentContent"
                :content="parentContent"
                type="parent"
                title="Dla rodzica"
            />
            <VodContentCarousel
                v-if="courseContent"
                :content="courseContent"
                type="course"
                title="Kursy"
            />
            <VodContentCarousel
                v-if="principalContent"
                :content="principalContent"
                type="principal"
                title="Dla dyrektora"
            />
            <VodConferencePreview
                :conference="conference"
                v-for="conference in $store.state.content.conferences"
                :key="conference.uuid"
            />
        </div>
    </div>
</template>
<script>
export default {
    components: {
        VodContentCarousel: () => import('./VodContentCarousel'),
        VodConferencePreview: () => import('./VodConferencePreview')
    },
    computed: {
        courseContent() {
            const content = this.$store.state.content.courses
            return content && content.length > 0 ? content : null
        },
        teacherContent() {
            const content = this.$store.getters['content/webinarsByType'](
                'teacher'
            )
            return content && content.length > 0 ? content : null
        },
        parentContent() {
            const content = this.$store.getters['content/webinarsByType'](
                'parent'
            )
            return content && content.length > 0 ? content : null
        },
        principalContent() {
            const content = this.$store.getters['content/webinarsByType'](
                'principal'
            )
            return content && content.length > 0 ? content : null
        },
        headerVisible() {
            return this.$store.state.content.conferences.length > 0
        }
    },
    methods: {
        goToConference() {
            this.$router.push('webinar/46c200fa-8fd3-46bb-893b-7076d97d72c4')
        }
    }
}
</script>
<style lang="scss" scoped>
.vod-content-header {
    width: 100%;
    height: 26rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 0;
    padding: 2rem;
    box-sizing: border-box;
    font-size: 1.5rem;
    overflow: hidden;

    h1,
    h2,
    h3,
    h4,
    p {
        margin: 0.2rem;
        max-width: 40rem;
    }
    p {
        font-size: 1rem;
        line-height: 1.4rem;
    }

    &::after {
        content: '';
        background-image: url('../../assets/img/headers/header-background.jpg');
        width: 100vw;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        z-index: -2;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.7;
    }
}
.header-photo {
    position: absolute;
    right: 0;
    height: 100%;
    display: flex;
    align-items: flex-start;
    z-index: -1;

    img {
        height: 100%;

        @media (max-width: 1000px) {
            display: none;
        }
    }
}
.vod-see-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    background: #1414149a;
    padding: 0.5rem 0.6rem;
    border-radius: 0.1rem;
    cursor: pointer;
    margin-top: 0.5rem;
    transition: $ease;
    font-family: $input-family;
    font-size: 1rem;
    color: #fff;

    &:hover {
        background: #fff;
        color: #141414;
    }

    i {
        font-size: 1.2rem;
        margin-right: 0.5rem;
        margin-top: -0.15rem;
    }
}
.vod-content-container {
    flex: 1;
    margin-top: -1rem;
    padding: 2rem;
    position: relative;

    @media (max-width: 1000px) {
        padding: 0rem;
    }

    &::after {
        content: '';
        pointer-events: none;
        position: absolute;
        background: linear-gradient(transparent 50%, var(--background) 70%);
        top: -5rem;
        left: 0;
        width: 100%;
        height: 7rem;
        opacity: 1;
    }

    &.without-header {
        margin-top: 4rem;
    }
}
</style>
